import { Cloudinary } from "cloudinary-core";
const cloudinary = new Cloudinary({ cloud_name: "unserwein" });

export default function useCloudinary(publicId, baseOptions) {
  // Currently this is no real React hook, but it might make sense to use one later.
  return function generateUrl(options) {
    return cloudinary.url(publicId, { ...baseOptions, ...options });
  };
}
